module.exports = __webpack_public_path__ + "img/Seccion4-Movil.f3968ff5.png";